<template>
  <header id="header" class="header">
    <div id="logo" class="grow">
      <svg class="logo__o" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><path stroke="#a63333" stroke-width="2" class="a" d="M16.78,2.83c8,0,14,6,14,14.36s-6.08,14.36-14,14.36-14-6-14-14.36C2.75,9.07,8.7,2.83,16.78,2.83Zm0,26.64c6.84,0,11.72-5.32,11.72-12.28S23.38,4.91,16.78,4.91,5.07,10.11,5.07,17.19,10.18,29.47,16.78,29.47Z"/></svg>
      <svg class="logo__a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><polygon stroke="#a63333" stroke-width="2" class="a" points="27.52 31.31 29.88 31.31 17.68 3.07 15.88 3.07 3.69 31.31 5.92 31.31 16.72 6.11 27.52 31.31"/></svg>      
      <svg class="logo__ver" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104 34"><path stroke="#a63333" stroke-width="2" class="a" d="M16.14,31H14.58L2.55,2.81H4.9L15.42,27.68,25.66,2.81H27.9Z"/><path stroke="#a63333" stroke-width="2" class="a" d="M32.78,2.81H48.26V4.89H35V15.56H47.06v2.08H35V28.72H48.66V30.8H32.78Z"/><path stroke="#a63333" stroke-width="2" class="a" d="M55.78,30.8v-28c1.56,0,5.92-.08,6.72-.08,7.64,0,9.8,3.8,9.8,8.07a8,8,0,0,1-6.64,7.8l9.8,12.2H72.74L63.42,19H58V30.8ZM58,4.89V17h4.84C66.38,17,70,14.52,70,10.8c0-3.39-1.92-6-7.6-6C61.54,4.81,59.3,4.85,58,4.89Z"/></svg>      
      <svg class="logo__bove" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104 34"><path stroke="#a63333" stroke-width="2" class="a" d="M3.08,2.93c1.56,0,4.92-.16,7.36-.16,6.68,0,8.84,3,8.84,6.92a6.55,6.55,0,0,1-5.44,6.55v.08c4,.48,6.52,2.8,6.52,6.72,0,5.6-4.28,8-10,8-2.4,0-5.68-.08-7.32-.16Zm2.2,2V15.6h5.44c3.48,0,6.36-2,6.36-5.47S15,4.85,10.36,4.85C8.64,4.85,6.4,4.93,5.28,5Zm0,12.59v11.2c1.12,0,3.44.16,5.2.16,4.8,0,7.68-2,7.68-6,0-3.44-2.72-5.36-7.56-5.36Z"/><path stroke="#a63333" stroke-width="2" class="a" d="M39.52,2.53c8,0,14,6,14,14.35s-6.08,14.36-14,14.36-14-6-14-14.36C25.48,8.77,31.44,2.53,39.52,2.53Zm0,26.63c6.84,0,11.72-5.32,11.72-12.28S46.12,4.61,39.52,4.61,27.8,9.81,27.8,16.88,32.92,29.16,39.52,29.16Z"/><path stroke="#a63333" stroke-width="2" class="a" d="M68.4,31.12H66.84L54.8,2.89h2.36L67.68,27.76,77.92,2.89h2.24Z"/><path stroke="#a63333" stroke-width="2" class="a" d="M85,2.89h15.48V5H87.24V15.65H99.32v2.07H87.24V28.8h13.68v2.08H85Z"/></svg>
      <span class="logo__and"></span>
    </div>
    <button id="menu-btn"><span>Menu</span></button>
    <Menu :bodyScrollBar="this.bodyScrollBar"/>
  </header>
</template>

<script>

import Menu from '@/components/structure/Menu.vue'


export default {
  name: 'Header',
  props: {
    bodyScrollBar: null
  },
  components: {
    Menu
  }
}
</script>

<scoped>

</scoped>
